import React, { Component } from 'react';
import moment from "moment";
import numeral from 'numeral';
import { connect } from 'react-redux';
import {List, Map} from "immutable";
import {Icon} from "@blueprintjs/core";
import _ from "lodash";
import {isFloat} from 'validator';

// Components
import Select from "../../../components/common/virtualized-select";
import QuoteLinesTable from "../../../components/common/QuoteLinesTable";
import StatusSelector from "../../../components/common/StatusSelector";
import DateInput from "../../../components/common/date-input";

// Actions
import {getCustomers, cleanCustomers} from "../../../actions/customers";
import {getCostBreakdowns, cleanCostBreakdowns} from "../../../actions/cost-breakdowns";
import {getProducts, getProduct, cleanProducts} from "../../../actions/products";

// Numeral configuration
import 'numeral/locales/es-es';

numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class QuoteDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canNewLine: false,
            // object fields
            quote_code: '',
            document_date: moment(),
            customer: -1,
            cost_breakdown: -1,
            comments: '',
            margin: 0,
            // costPrices
            products: List([]),
            costPrices: List([Map({ _id: -1, price: "Selecciona un precio" })]),
            selectedCostPrice: -1,
            // preview line
            newLinePvp: 0,
            newLineDiscount: 0,
            newLineVat: 0,
            lines: List([]),
            // lines
            product: -1,
            commentsLine: '',
            amount: 0,
            cost_price: 0,
            sale_price: 0,
            discount: 0,
            vat: 0,
            total: 0,
            // Statistics
            quoteSubtotal: numeral(0).format(),
            quoteVat: numeral(0).format(),
            quoteTotal: numeral(0).format(),
            // line edit index
            lineToEditIndex: -1
        }
    }
    componentDidMount() {
        this.updateQuoteState();
        this.props.onRef(this);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.quote !== prevProps.quote) {
            this.updateQuoteState();
        }

        // Calculate Statistics
        if (this.state.lines !== prevState.lines) {
            let quoteSubtotal = 0, quoteVat = 0, quoteTotal = 0;

            this.state.lines.forEach(line => {
                // let subtotalCost, discount, subtotal, vat;
                //
                // subtotalCost = line.get('amount') * line.get('sale_price');
                // discount = subtotalCost * (_.round(line.get('discount'), 2) / 100);
                // subtotal = subtotalCost - discount;
                // vat = subtotal * (_.round(line.get('vat'), 2) / 100);
                //
                // quoteSubtotal = quoteSubtotal + subtotalCost;
                // quoteVat = quoteVat + vat;
                // quoteTotal = quoteTotal + line.get('total');

                const calcLine = this.calculateLine(line.get('amount'), line.get('cost_price'), this.state.margin, line.get('discount'), line.get('vat'));

                quoteSubtotal = quoteSubtotal + calcLine.subtotal;
                quoteVat = quoteVat + calcLine.vatLine;
                quoteTotal = quoteTotal + calcLine.total;
            });

            this.setState({
                quoteSubtotal: numeral(quoteSubtotal).format(),
                quoteVat: numeral(quoteVat).format(),
                quoteTotal: numeral(quoteTotal).format()
            });
        }

        // On Edit Mode
        if (this.props.editMode !== prevProps.editMode && this.props.editMode) {
            this.props.getCustomers({
                filters: {
                    status: 'active'
                },
                projection: 'customer_code basic_info.name',
                deleteVirtuals: true
            });
            this.props.getProducts({
                filters: {
                    status: 'active'
                },
                projection: 'product_code name',
                deleteVirtuals: true
            });
            this.props.getCostBreakdowns({
                projection: 'breakdown_code name',
                deleteVirtuals: true
            });
        }

        // Handle products and costPrices
        let products = this.props.products;
        if (products !== prevProps.products) {
            if (products instanceof List) {
                if (products.size > 0) {
                    products = products.map(product => {
                        return product.set('select', `[${product.get('product_code')}] ${product.get('name')}`);
                    });
                }
                products = products.insert(0, Map({ _id: -1, select: 'Selecciona un producto' }));
                this.setState({ products });
            }
            else {
                if (products.get('cost_prices')) {
                    this.setState({
                        costPrices: products.get('cost_prices').insert(0, Map({ _id: -1, price: "Selecciona un precio" }))
                    });
                }
            }
        }
    }
    componentWillUnmount() {
        this.props.cleanProducts();
        this.props.cleanCostBreakdowns();
        this.props.cleanCustomers();
        this.props.onRef(undefined);
    }

    updateQuote = () => {
        let lines = new List([]);
        this.state.lines.forEach(line => {
            lines = lines.insert(lines.size, line
                .set('product', line.getIn(['product', '_id']))
                .delete('sale_price')
                .delete('total')
            );
        });

        this.props.updateQuote(this.props.quote.get('_id'), {
            // object fields
            quote_code: this.state.quote_code,
            document_date: this.state.document_date,
            customer: this.state.customer,
            ...(this.state.cost_breakdown !== -1) ? { cost_breakdown: this.state.cost_breakdown } : '',
            comments: this.state.comments,
            margin: this.state.margin,
            lines
        });
    };
    updateQuoteState = () => {
        this.setState({
            // object fields
            quote_code: this.props.quote.get('quote_code'),
            document_date: moment(this.props.quote.get('document_date')),
            customer: this.props.quote.getIn(['customer','_id']),
            cost_breakdown: this.props.quote.getIn(['cost_breakdown', '_id']) || -1,
            comments: this.props.quote.get('comments'),
            margin: this.props.quote.get('margin'),
            // preview line
            newLinePvp: 0,
            newLineDiscount: 0,
            newLineVat: 0,
            lines: this.props.quote.get('lines'),
            // lines
            product: -1,
            commentsLine: '',
            amount: 0,
            cost_price: 0,
            sale_price: 0,
            discount: 0,
            vat: 0,
            total: 0,
            // statistics
            quoteSubtotal: numeral(this.props.quote.getIn(['statistics', 'subtotal'])).format(),
            quoteVat: numeral(this.props.quote.getIn(['statistics', 'vat'])).format(),
            quoteTotal: numeral(this.props.quote.getIn(['statistics', 'total'])).format(),
            // line edit index
            lineToEditIndex: -1
        })
    };
    getLineToEdit = index => {
        const line = this.state.lines.get(index);
        const calcLine = this.calculateLine(line.get('amount'), line.get('cost_price'), this.state.margin, line.get('discount'), line.get('vat'));

        window.scrollTo(0, 0);

        this.props.getProduct(line.getIn(['product', '_id']), {
            projection: '_id',
            populateRefs: true
        });

        this.setState({
            product: line.getIn(['product', '_id']),
            selectedCostPrice: -1,
            commentsLine: line.get('comments'),
            amount: line.get('amount'),
            cost_price: line.get('cost_price'),
            sale_price: calcLine.salePrice,
            discount: line.get('discount'),
            vat: line.get('vat'),
            newLinePvp: _.round(calcLine.subtotalCost, 2),
            newLineDiscount: _.round(calcLine.discountLine, 2),
            newLineVat: _.round(calcLine.vatLine, 2),
            total: calcLine.total,
            lineToEditIndex: index
        }, this.validateLine);
    };
    deleteLine = index => {
        this.setState({
            lines: this.state.lines.delete(index)
        }, this.validateQuote);
    };
    validateLine = () => {
        if (
            this.state.product !== -1 &&
            this.state.amount > 0
        ) {
            this.setState({ canNewLine: true });
        } else {
            this.setState({ canNewLine: false });
        }
    };
    validateQuote = () => {
        if (
            this.state.document_date.isValid() &&
            this.state.customer !== -1 &&
            this.state.margin !== ''
        ) {
            this.props.canSubmit(true);
        } else {
            this.props.canSubmit(false);
        }
    };
    calculateLine = (amount, costPrice, margin, discount, vat) => {
        let salePrice, subtotalCost, discountLine, subtotal, vatLine, total;
        salePrice = _.round(_.round(costPrice, 5) / (1 - (_.round(margin, 2) / 100)), 2);
        subtotalCost = _.round(amount, 5) * salePrice;
        discountLine = subtotalCost * (_.round(discount, 2) / 100);
        subtotal = subtotalCost - discountLine;
        vatLine = subtotal * (_.round(vat, 2) / 100);
        total = _.round(subtotal + vatLine, 2);

        return {
            salePrice,
            subtotalCost,
            discountLine,
            subtotal,
            vatLine,
            total
        }
    };

    render() {
        let quoteDetail;
        let statusColor = '', statusText = '';

        switch (this.props.quote.get('status')) {
            case 'pending':
                statusColor = 'warning';
                statusText = 'Pendiente';
                break;
            case 'accepted':
                statusColor = 'primary';
                statusText = 'Aceptado';
                break;
            case 'rejected':
                statusColor = 'danger';
                statusText = 'Rechazado';
                break;
            default:
                break;
        }

        if (!this.props.editMode) {
            quoteDetail = (
                <div className="panel-body" >
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Código de presupuesto *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={ this.props.quote.get('quote_code') }
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Fecha presupuesto *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={moment(this.props.quote.get('document_date')).format('DD/MM/YYYY')}
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className="ml-auto col-3">
                            <div className="form-group">
                                <label>Estado</label>
                                <div className="row">
                                    <div className="col-6">
                                        <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                    </div>
                                    <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                        <StatusSelector
                                            statusObject={this.props.quote}
                                            statusOptions={['pending', 'accepted', 'rejected']}
                                            changeStatus={this.props.changeQuoteStatus}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ paddingBottom: 16 }} >
                        <div className="col-6">
                            <label>Cliente *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.props.quote.getIn(['customer', 'basic_info', 'name'])}
                                disabled={true}
                            />
                        </div>
                        <div className="col-6">
                            <label>Escandallo de Costes</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.props.quote.getIn(['cost_breakdown', 'name'])}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row" style={{ paddingBottom: 16 }} >
                        <div className="col-9">
                            <label>Comentarios</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.props.quote.get('comments')}
                                disabled={true}
                            />
                        </div>
                        <div className="col-3">
                            <label>Margen (%) *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.props.quote.get('margin')}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <h4>Lineas de presupuesto</h4>
                    <QuoteLinesTable
                        quoteLines={this.props.quote.get('lines')}
                    />
                    <div className="row stats-zone d-flex justify-content-end">
                        <div className="col-auto">
                            <span className="label ">{ numeral(this.props.quote.getIn(['statistics', 'subtotal'])).format() }</span>
                            <span>Subtotal</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ numeral(this.props.quote.getIn(['statistics', 'vat'])).format() }</span>
                            <span>IVA</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ numeral(this.props.quote.getIn(['statistics', 'total'])).format() }</span>
                            <span>Total</span>
                        </div>
                    </div>
                </div>
            );
        }
        else {
            quoteDetail = (
                <div className="panel-body" >
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Código de presupuesto *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={ this.props.quote.get('quote_code') }
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Fecha presupuesto *</label>
                                <DateInput
                                    onChange={(selectedDate) => {
                                        this.setState({
                                            document_date: selectedDate
                                        }, this.validateQuote);
                                    }}
                                    value={this.state.document_date}
                                    inputWrapperStyle={{height: 40}}
                                    inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                    iconStyle={{top: 9, right: 12}}
                                />
                            </div>
                        </div>
                        <div className="ml-auto col-3">
                            <div className="form-group">
                                <label>Estado</label>
                                <div className="row">
                                    <div className="col-6">
                                        <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ paddingBottom: 16 }} >
                        <div className="col-6">
                            <label>Cliente *</label>
                            <Select
                                className="virtualized-select"
                                options={this.props.customers.toJS()}
                                value={this.state.customer}
                                labelKey="select"
                                valueKey="_id"
                                matchProp="select"
                                multi={false}
                                searchable={true}
                                clearable={false}
                                onChange={(customer) => {
                                    if (customer && customer._id !== this.state.customer) {
                                        this.setState({
                                            customer: customer._id,
                                        }, this.validateQuote);
                                    }
                                }}
                            />
                        </div>
                        <div className="col-6">
                            <label>Escandallo de Costes</label>
                            <Select
                                className="virtualized-select"
                                options={this.props.costBreakdowns.toJS()}
                                value={this.state.cost_breakdown}
                                labelKey="select"
                                valueKey="_id"
                                matchProp="select"
                                multi={false}
                                searchable={true}
                                clearable={false}
                                onChange={(costBreakdown) => {
                                    if (costBreakdown && costBreakdown._id !== this.state.cost_breakdown) {
                                        this.setState({
                                            cost_breakdown: costBreakdown._id,
                                        });
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="row" style={{ paddingBottom: 16 }} >
                        <div className="col-9">
                            <label>Comentarios</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.comments}
                                onChange={ (event) => {
                                    this.setState({
                                        comments: event.target.value
                                    }, this.validateQuote);
                                }}
                            />
                        </div>
                        <div className="col-3">
                            <label>Margen (%) *</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.margin}
                                onChange={ (event) => {
                                    let margin = event.target.value;
                                    let lines = List([]);
                                    let calcLine = {};

                                    if (margin === '') margin = '0';
                                    if (margin >= 100) margin = '99';
                                    if (isFloat(margin)) {
                                        // actual lines
                                        this.state.lines.forEach(line => {
                                            calcLine = this.calculateLine(line.get('amount'), line.get('cost_price'), margin, line.get('discount'), line.get('vat'));
                                            lines = lines.push(Map({
                                                _id: line.get('_id'),
                                                product: line.get('product'),
                                                comments: line.get('comments'),
                                                amount: line.get('amount'),
                                                cost_price: line.get('cost_price'),
                                                sale_price: calcLine.salePrice,
                                                discount: line.get('discount'),
                                                vat: line.get('vat'),
                                                total: calcLine.total
                                            }));
                                        });
                                        // new line
                                        calcLine = this.calculateLine(this.state.amount, this.state.cost_price, margin, this.state.discount, this.state.vat);
                                        this.setState({
                                            margin: _.round(margin, 2),
                                            sale_price: calcLine.salePrice,
                                            newLinePvp: _.round(calcLine.subtotalCost, 2),
                                            newLineDiscount: _.round(calcLine.discountLine, 2),
                                            newLineVat: _.round(calcLine.vatLine, 2),
                                            total: calcLine.total,
                                            lines
                                        }, this.validateQuote);
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <h4>Lineas de presupuesto { this.state.lineToEditIndex !== -1 ? <span style={{
                        paddingLeft: '50px',
                        color: '#1AB394',
                        fontStyle: 'italic',
                        fontWeight: 'bold'
                    }}>- Modo edición de línea -</span> : '' }</h4>
                    <div style={{
                        transition: 'all 0.4s',
                        margin: '0 -10px',
                        padding: '10px 10px 0',
                        ...this.state.lineToEditIndex !== -1 ? { boxShadow: '0 0 10px 1px #1AB394' } : {}
                    }}>
                        <div className="row" style={{ paddingBottom: 16 }} >
                            <div className="col-3">
                                <label>Producto *</label>
                                <Select
                                    className="virtualized-select"
                                    options={this.state.products.toJS()}
                                    value={this.state.product}
                                    labelKey="select"
                                    valueKey="_id"
                                    matchProp="select"
                                    multi={false}
                                    searchable={true}
                                    clearable={false}
                                    onChange={(product) => {
                                        if (product && product._id !== this.state.product) {
                                            this.props.getProduct(product._id, {
                                                projection: '_id',
                                                populateRefs: true
                                            });
                                            this.setState({
                                                product: product._id,
                                                selectedCostPrice: -1
                                            }, this.validateLine);
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-3">
                                <label>Últimos costes del producto</label>
                                <Select
                                    className="virtualized-select"
                                    options={this.state.costPrices.toJS()}
                                    value={this.state.selectedCostPrice}
                                    labelKey="price"
                                    valueKey="_id"
                                    matchProp="price"
                                    multi={false}
                                    searchable={true}
                                    clearable={false}
                                    disabled={this.state.product === -1 || this.state.costPrices.size <= 1}
                                    onChange={(selectedCostPrice) => {
                                        if (selectedCostPrice) {
                                            if (selectedCostPrice._id !== -1) {
                                                let cost_price = selectedCostPrice.price;
                                                let calcLine = {};

                                                if (cost_price === '') cost_price = '0';
                                                if (isFloat(cost_price.toString())) {
                                                    calcLine = this.calculateLine(this.state.amount, cost_price, this.state.margin, this.state.discount, this.state.vat);
                                                    this.setState({
                                                        selectedCostPrice: selectedCostPrice._id,
                                                        cost_price,
                                                        sale_price: calcLine.salePrice,
                                                        newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                        newLineDiscount: _.round(calcLine.discountLine, 2),
                                                        newLineVat: _.round(calcLine.vatLine, 2),
                                                        total: calcLine.total
                                                    }, this.validateLine);
                                                }
                                            }
                                            else {
                                                this.setState({ selectedCostPrice: selectedCostPrice._id });
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row" style={{ paddingBottom: 16 }} >
                            <div className="col-6">
                                <label>Comentarios</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.commentsLine}
                                    onChange={ (event) => {

                                        this.setState({
                                            commentsLine: event.target.value
                                        });
                                    }}
                                    disabled={this.state.product === -1}
                                />
                            </div>
                        </div>
                        <div className="row" style={{ paddingBottom: 16 }} >
                            <div className="col">
                                <label>Cantidad *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.amount}
                                    onChange={ (event) => {
                                        let amount = event.target.value;
                                        let calcLine = {};

                                        if (amount === '') amount = '0';
                                        if (isFloat(amount)) {
                                            calcLine = this.calculateLine(amount, this.state.cost_price, this.state.margin, this.state.discount, this.state.vat);
                                            this.setState({
                                                amount,
                                                sale_price: calcLine.salePrice,
                                                newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                newLineDiscount: _.round(calcLine.discountLine, 2),
                                                newLineVat: _.round(calcLine.vatLine, 2),
                                                total: calcLine.total
                                            }, this.validateLine);
                                        }
                                    }}
                                    disabled={this.state.product === -1}
                                />
                            </div>
                            <div className="col">
                                <label>Precio coste ud *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.cost_price}
                                    onChange={ (event) => {
                                        let cost_price = event.target.value;
                                        let calcLine = {};

                                        if (cost_price === '') cost_price = '0';
                                        if (isFloat(cost_price)) {
                                            calcLine = this.calculateLine(this.state.amount, cost_price, this.state.margin, this.state.discount, this.state.vat);
                                            this.setState({
                                                cost_price,
                                                sale_price: calcLine.salePrice,
                                                newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                newLineDiscount: _.round(calcLine.discountLine, 2),
                                                newLineVat: _.round(calcLine.vatLine, 2),
                                                total: calcLine.total
                                            });
                                        }
                                    }}
                                    disabled={this.state.product === -1}
                                />
                            </div>
                            <div className="col">
                                <label>PVP ud *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.sale_price}
                                    disabled={true}
                                />
                            </div>
                            <div className="col">
                                <label>Descuento (%)</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.discount}
                                    onChange={ (event) => {
                                        let discount = event.target.value;
                                        let calcLine = {};

                                        if (discount === '') discount = '0';
                                        if (isFloat(discount)) {
                                            calcLine = this.calculateLine(this.state.amount, this.state.cost_price, this.state.margin, discount, this.state.vat);
                                            this.setState({
                                                discount,
                                                newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                newLineDiscount: _.round(calcLine.discountLine, 2),
                                                newLineVat: _.round(calcLine.vatLine, 2),
                                                total: calcLine.total
                                            });
                                        }
                                    }}
                                    disabled={this.state.product === -1}
                                />
                            </div>
                            <div className="col">
                                <label>IVA (%) *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.vat}
                                    onChange={ (event) => {
                                        let vat = event.target.value;
                                        let calcLine = {};

                                        if (vat === '') vat = '0';
                                        if (isFloat(vat)) {
                                            calcLine = this.calculateLine(this.state.amount, this.state.cost_price, this.state.margin, this.state.discount, vat);
                                            this.setState({
                                                vat,
                                                newLinePvp: _.round(calcLine.subtotalCost, 2),
                                                newLineDiscount: _.round(calcLine.discountLine, 2),
                                                newLineVat: _.round(calcLine.vatLine, 2),
                                                total: calcLine.total
                                            });
                                        }
                                    }}
                                    disabled={this.state.product === -1}
                                />
                            </div>
                            <div className="col">
                                <label>PVP (€) *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.newLinePvp}
                                    disabled={true}
                                />
                            </div>
                            <div className="col">
                                <label>Descuento (€) *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.newLineDiscount}
                                    disabled={true}
                                />
                            </div>
                            <div className="col">
                                <label>IVA (€) *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.newLineVat}
                                    disabled={true}
                                />
                            </div>
                            <div className="col">
                                <label>Total (€) *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.total}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-auto" style={{ paddingTop: 23 }} >
                                { this.state.lineToEditIndex !== -1
                                    ? <button
                                        className="btn btn-primary"
                                        disabled={!this.state.canNewLine}
                                        onClick={() => {
                                            let lines = new List(this.state.lines);
                                            let index = this.state.products.findIndex( product => product.get('_id') === this.state.product );
                                            const product = this.state.products.get(index);

                                            lines = lines.set(this.state.lineToEditIndex, Map({
                                                product,
                                                comments: this.state.commentsLine,
                                                amount: _.round(this.state.amount, 5),
                                                cost_price: _.round(this.state.cost_price, 5),
                                                sale_price: this.state.sale_price,
                                                discount: _.round(this.state.discount, 2),
                                                vat: _.round(this.state.vat, 5),
                                                total: _.round(this.state.total, 2)
                                            }));

                                            this.setState({
                                                lines,
                                                product: -1,
                                                selectedCostPrice: -1,
                                                commentsLine: '',
                                                amount: 0,
                                                cost_price: 0,
                                                sale_price: 0,
                                                vat: 0,
                                                newLinePvp: 0,
                                                newLineDiscount: 0,
                                                newLineVat: 0,
                                                discount: 0,
                                                total: 0,
                                                canNewLine: false,
                                                lineToEditIndex: -1
                                            }, this.validateQuote);
                                        }}
                                    >
                                        <Icon
                                            style={{ margin: '2px 0px' }}
                                            icon="tick" title="Guardar"
                                        />
                                    </button>
                                    : <button
                                        className="btn btn-custom"
                                        disabled={!this.state.canNewLine}
                                        onClick={() => {
                                            let lines = new List(this.state.lines);
                                            let index = this.state.products.findIndex( product => product.get('_id') === this.state.product );
                                            const product = this.state.products.get(index);

                                            lines = lines.insert(lines.size, Map({
                                                product,
                                                comments: this.state.commentsLine,
                                                amount: _.round(this.state.amount, 5),
                                                cost_price: _.round(this.state.cost_price, 5),
                                                sale_price: this.state.sale_price,
                                                discount: _.round(this.state.discount, 2),
                                                vat: _.round(this.state.vat, 5),
                                                total: _.round(this.state.total, 2)
                                            }));

                                            this.setState({
                                                lines,
                                                product: -1,
                                                selectedCostPrice: -1,
                                                commentsLine: '',
                                                amount: 0,
                                                cost_price: 0,
                                                sale_price: 0,
                                                vat: 0,
                                                newLinePvp: 0,
                                                newLineDiscount: 0,
                                                newLineVat: 0,
                                                discount: 0,
                                                total: 0,
                                                canNewLine: false
                                            }, this.validateQuote);
                                        }}
                                    >
                                        <Icon
                                            style={{ margin: '2px 0px' }}
                                            icon="plus" title="Añadir"
                                        />
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                    <QuoteLinesTable
                        editMode={true}
                        quoteLines={this.state.lines}
                        deleteLine={this.deleteLine}
                        getLineToEdit={this.getLineToEdit}
                        editLineIndex={this.state.lineToEditIndex}
                    />
                    <div className="row stats-zone d-flex justify-content-end">
                        <div className="col-auto">
                            <span className="label ">{ this.state.quoteSubtotal }</span>
                            <span>Subtotal</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.state.quoteVat }</span>
                            <span>IVA</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ this.state.quoteTotal }</span>
                            <span>Total</span>
                        </div>
                    </div>
                </div>
            );
        }

        return quoteDetail;
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const customersReducer = state.customers;
    const costBreakdownsReducer = state.costBreakdowns;
    const productsReducer = state.products;

    // Customers
    let customers = customersReducer.get('payload') || List([]);
    if (!(customers instanceof List)) customers = List([]);
    if (customers.size > 0) {
        customers = customers.map(customer => {
            return customer.set('select', `[${customer.get('customer_code')}] ${customer.getIn(['basic_info', 'name'])}`);
        });
    }
    customers = customers.insert(0, Map({ _id: -1, select: 'Selecciona un cliente' }));

    // CostBreakdowns
    let costBreakdowns = costBreakdownsReducer.get('payload') || List([]);
    if (!(costBreakdowns instanceof List)) costBreakdowns = List([]);
    if (costBreakdowns.size > 0) {
        costBreakdowns = costBreakdowns.map(costBreakdown => {
            return costBreakdown.set('select', `[${costBreakdown.get('breakdown_code')}] ${costBreakdown.get('name')}`);
        });
    }
    costBreakdowns = costBreakdowns.insert(0, Map({ _id: -1, select: 'Selecciona un escandallo de costes' }));

    // Products
    const products = productsReducer.get('payload') || List([]);

    return {
        customers,
        costBreakdowns,
        products
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCustomers: (query) => dispatch(getCustomers(query)),
        getCostBreakdowns: (query) => dispatch(getCostBreakdowns(query)),
        getProducts: (query) => dispatch(getProducts(query)),
        getProduct: (productId, options) => dispatch(getProduct(productId, options)),
        cleanCustomers: () => dispatch(cleanCustomers()),
        cleanCostBreakdowns: () => dispatch(cleanCostBreakdowns()),
        cleanProducts: () => dispatch(cleanProducts())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuoteDetail);



// WEBPACK FOOTER //
// ./src/containers/sales/quotes/QuoteDetail.js